package com.sweetlime.bingeamigo.presentation.features.notifications

import androidx.lifecycle.ViewModel
import androidx.lifecycle.viewModelScope
import com.sweetlime.bingeamigo.model.AppNotification
import com.sweetlime.bingeamigo.repository.AppNotificationsRepository
import com.sweetlime.bingeamigo.repository.AuthRepository
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.coroutines.launch

data class NotificationsUiState(
    val notifications: List<AppNotification> = emptyList(),
    val isLoading: Boolean = true
)

class NotificationsViewModel(
    private val repository: AppNotificationsRepository,
    private val authRepository: AuthRepository
) : ViewModel() {

    private val _uiState = MutableStateFlow(NotificationsUiState())
    val uiState: StateFlow<NotificationsUiState> = _uiState.asStateFlow()

    fun load() {
        val uid = authRepository.currentUserId() ?: return
        viewModelScope.launch {
            repository.observeNotifications(uid).collect { list ->
                _uiState.value = NotificationsUiState(notifications = list, isLoading = false)
            }
        }
    }

    fun markAsRead(notificationId: String) {
        val uid = authRepository.currentUserId() ?: return
        viewModelScope.launch { repository.markAsRead(uid, notificationId) }
    }

    fun markAllAsRead() {
        val uid = authRepository.currentUserId() ?: return
        viewModelScope.launch { repository.markAllAsRead(uid) }
    }
}